import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner';

export default class Loading extends Component {
    render() {
        return (
            <div className="container h-100 d-flex justify-content-center">
                <div className="my-auto">
                    <Spinner animation="border" role="status" variant="primary" />
                </div>
            </div>
        );
    }
}
